import styled from "styled-components";

export const Content = styled.div`
  display: flex;

  .content-wrapper {
    display: flex;
    flex-direction: column;

    width: 35rem;
    height: 10rem;

    background-color: white;

    border-radius: 0.5rem;

    padding: 0.25rem 0 0 0;
  }

  .header {
    display: flex;

    align-items: center;

    height: 2rem;
    width: 100%;

    padding-bottom: 0.5rem;

    border-bottom: #dfe0eb solid 1px;

    font-family: "Mulish";
    font-weight: 600;
  }

  .filter {
    display: flex;

    color: #8a8a8a;

    justify-content: space-between;
    align-items: center;

    width: 8rem;
  }

  .filter > button {
    border: none;
    background: none;

    cursor: pointer;
  }

  .filter > p {
    text-transform: uppercase;
  }

  .bellow-header {
    display: flex;
    width: 100%;
    height: 100%;
  }

  .approveds {
    display: flex;
    flex-direction: column;

    border-right: #dfe0eb solid 1px;

    align-items: center;
    justify-content: center;

    width: 33%;

    height: 100%;
  }

  #numb-apr {
    font-size: 3rem;

    color: #228d19;
  }

  #apr {
    font-family: "Mulish";
    font-weight: 600;
  }

  .pending {
    display: flex;
    flex-direction: column;

    border-right: #dfe0eb solid 1px;

    align-items: center;
    justify-content: center;

    width: 33%;

    height: 100%;
  }

  #numb-pending {
    font-size: 3rem;

    color: #e8652c;
  }

  .disapproved {
    display: flex;
    flex-direction: column;

    align-items: center;
    justify-content: center;

    width: 33%;

    height: 100%;
  }

  #numb-disapproved {
    font-size: 3rem;

    color: #d11919;
  }
`;
